import * as yup from 'yup';

export interface IStepPayment {
    cardNumber: string;
    expiryDate: string;
    cvc: string;
    automaticPayments: boolean;
}

export const stepPaymentInitialValues: IStepPayment = {
    cardNumber: '',
    expiryDate: '',
    cvc: '',
    automaticPayments: true
}

export const stepPaymentSchema = yup.object().shape({
    cardNumber: yup
        .string()
        .matches(/^[0-9]{15,20}$/, 'wrongFormat')
        .required('required'),
    expiryDate: yup
        .string()
        .matches(/^[0-9]{2}\/?[0-9]{2}$/, 'wrongFormat')
        .required('required'),
    cvc: yup
        .string()
        .matches(/^[0-9]{3}$/, 'wrongFormat')
        .required('required'),
    automaticPayments: yup.boolean()
});
